// extracted by mini-css-extract-plugin
export const flexibleContentContainer = "generic-module--flexibleContentContainer--av2lc";